module.exports = __webpack_public_path__ + "img/home1_yinliu_logo.158d96f6.png";